<template>
  <el-dialog :title="title"
             :visible.sync="visible"
             :lock-scroll="true"
             width="1218px"
             :before-close="handleClose">
    <div class="">
      <div>
        <el-form ref="form-data"
                 style="margin: 0px !important;display: flex;"
                 :model="formToolS"
                 :inline="false"
                 label-position="right">
          <el-form-item label="">
            <el-input v-model.trim="formToolS.orderCode"
                      style="width: 200px;"
                      placeholder="请输入申请ID"
                      clearable
                      size="small" />
          </el-form-item>
          <el-form-item label="">
            <el-date-picker style="width: 240px;margin-left:16px"
                            v-model="formToolS.date"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            size="small"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间" />
          </el-form-item>
          <el-form-item label="">
            <el-button size="small"
                       style="margin-left:16px"
                       type="primary"
                       @click="getList(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="center"
           style="position: relative">
        <MyTable :table-data="tableData"
                 style="height: calc(100% - 35px);"
                 :index="index"
                 :selection="selection"
                 :page="page"
                 :operation="operation"
                 :table-option.sync="tableOption"
                 @page-change="getList">
          <template slot="province"
                    slot-scope="scope">
            {{ scope.row.province + scope.row.city + scope.row.district}}
          </template>
        </MyTable>
      </div>
    </div>
  </el-dialog>
</template>
    
<script>
import MyTable from "@/components/myTable";
import fileUpload from "@/components/fileUpload";
import { payvoucherinfoDetail } from "@/api/surety";
import avater from "/public/img/default.png";
import imgUpload from '@/components/imgUpload';
export default {
  props: {
    voucherId: {
      type: String,
      default: ''
    }
  },
  components: { imgUpload, fileUpload, MyTable },

  data () {
    return {
      fileList: [
        // {
        //   "url": "https://eshop-develop.oss-cn-hangzhou.aliyuncs.com/goods/店铺32131_2023110509455080757858.png",
        //   "name": "店铺32131_2023110509455080757858.png",
        //   "status": "success"
        // }
      ],
      avater: avater,
      disabled: false,
      id: '',
      pageType: '',
      isDisabled: false,
      formToolS: {
        orderCode: '',
        date: []
      },

      title: '缴费明细',
      index: true,
      selection: false,
      visible: false,
      fileListShow: true,
      operation: false,
      tableData: [],
      tableOption: [
        { label: "订单创建时间", prop: "createTime" },
        { label: "订单ID", prop: "orderCode" },
        { label: "客户ERP编码", prop: "erpShopCode" },
        { label: "运营项目", prop: "deptName" },
        { label: "客户名称", prop: "payShopName" },
        { label: "客户所在区域", prop: "province", slot: true },
        { label: "商品总额（元）", prop: "amount" },
        { label: "运费（元）", prop: "freightPrice" },
        { label: "商家优惠金额（元）", prop: "coupon" },
        { label: "平台补贴（元）", prop: "platformSubsidy" },
        { label: "退款金额（元）", prop: "refundAmount" },
        { label: "技术服务费（元）", prop: "technicalMoney" },
        { label: "推广服务费（元）", prop: "promotionMoney" },
        { label: "结算金额（元）", prop: "settlementAmount" },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
    }
  },
  created () {

  },
  mounted () {

  },
  watch: {},
  methods: {
    saveSubmit () {
      // this.$refs['add-dialog'].init({}, 'edit')
    },
    getList (current) {
      if (current) {
        this.page.current = current;
      }
      const params = {
        ...this.formToolS,
        current: this.page.current,
        size: this.page.size,
        voucherId: this.voucherId
      };
      if (this.formToolS.date) {
        params.strTime = this.formToolS.date[0];
        params.endTime = this.formToolS.date[1];
      }
      payvoucherinfoDetail(params).then(res => {
        if (res) {
          this.tableData = res.records;
          this.page.total = res.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
        this.$nextTick(() => { this.visible = true; })
      })
    },

    init () {
      this.getList()
      this.visible = true;
    },
    handleClose () {
      this.visible = false;
    },
  }
}

</script>
<style lang="scss" scoped>
.center {
  height: 500px;
}
.eachRow {
  background-color: #fff;
  border-radius: 4px;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
}

.titleView {
  display: flex;
  align-items: center;

  .rowLine {
    width: 4px;
    border-color: 1px;
    background-color: var(--main-color);
    height: 16px;
    margin-right: 8px;
  }

  .eachRowTitle {
    font-size: 16px;
    color: #262626;
    font-weight: 600;
  }

  .cpxhead {
    display: flex;
    align-items: center;
  }

  .mark {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 10px;
    width: 200px;
    line-height: 1.5;
    display: inline-block;
    font-weight: bold;
  }
}

.goods-list-warp {
  width: 100%;
  margin-left: 100px;
  max-height: 500px;
  overflow-y: auto;
}

.goods-list {
  width: 50%;
  border-bottom: solid 1px #f5f5f5;
  padding-bottom: 10px;

  &:nth-last-child(1) {
    border-bottom: none;
  }
}

.footer-btn {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
</style>
  
  